export default "__VITE_ASSET__CxD9nzGT__"